import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import AuthProvider from '@providers/AuthProvider';
import AppRoutes from '@pages/AppRoutes';
import { ThemeProvider } from '@mui/material/styles';
import theme from '@modules/theme';
import UserProvider from '@providers/UserProvider';
import TeamProvider from '@providers/TeamProvider';
import ModalProvider from '@providers/ModalProvider';
// If you are using date-fns v3.x or v4.x, please import the v3 adapter
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider/LocalizationProvider';
import StripeAccountProvider from '@providers/StripeAccountProvider';
import PaymentProvider from '@providers/PaymentProvider';
import ManagedEventsProvider from '@providers/ManagedEventsProvider';

export default function App() {
    return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <AuthProvider>
                <UserProvider>
                    <StripeAccountProvider>
                        <TeamProvider>
                            <ManagedEventsProvider>
                                <ThemeProvider theme={theme}>
                                    <ModalProvider>
                                        <PaymentProvider>
                                            <AppRoutes />
                                        </PaymentProvider>
                                    </ModalProvider>
                                </ThemeProvider>
                            </ManagedEventsProvider>
                        </TeamProvider>
                    </StripeAccountProvider>
                </UserProvider>
            </AuthProvider>
        </LocalizationProvider>
    );
}
